/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Theme } from '@mui/material';
import { withStyles } from '@mui/styles';
import * as React from 'react';
import { exportTrainingAuthorizationPdf } from '../common/AuthorizationModel';
import { categories, Category } from '../common/Categories';
import { exportData } from '../common/common';
import { loadFromLocalStorage } from '../common/localStorage';
import { history } from '../store/history';
import { dataTableRenderer, getExportQueryFromGridRequest, loadTableData } from './AuthorizationRenderer';

interface Props {
    classes?: any;
}
const styles = (theme: Theme) => ({
    table: {
        width: '100%',
        padding: '12px'
    },
    progress: {
        margin: ((theme as any) && typeof (theme as any).spacing === 'function') ? (theme as any).spacing(2) : '16px'
    },
    progressWrap: {
        textAlign: 'center' as const,
        marginTop: '20vh'
    },
});

class MyTrainingAuthorizations extends React.Component<Props>{
    state = {
        selectedCategory: categories.find((category: Category) => {
            return category.id === 8;
        }),
        rows: [],
        totalRows: 0,
        isLoading: true,
        initialLoading: true,
        isModuleEnabled: false,
        norecords: false
    };
    componentDidMount() {
        const enabledModules: Array<any> = loadFromLocalStorage('Enabled Modules');
        let isModuleEnabled = false;
        if (this.state.selectedCategory !== undefined) {
            isModuleEnabled = enabledModules != null ?
                enabledModules.find(x => this.state.selectedCategory !== undefined && x.modulename === this.state.selectedCategory.moduleName) !== undefined : false;
        }
        console.log('MyTrainingAuthorizations - isModuleEnabled:', isModuleEnabled, 'enabledModules:', enabledModules);
        this.setState({ isModuleEnabled });
        if (!isModuleEnabled) {
            console.warn('Module not enabled, redirecting to /app');
            history.push('/app');
            return;
        }
        console.log('Loading training data...');
        this.loadData({ pageno: 1, pagesize: 10 });
    }
    async loadData(extras: any) {
        if (this.state.selectedCategory !== undefined) {
            this.setState({ isLoading: true, rows: [] });
            const data = await loadTableData(extras, this.state.selectedCategory);
            console.log('Received data:', data);
            if (data !== undefined) {
                this.setState({
                    rows: data.rows, totalRows: data.totalRows, isLoading: false, initialLoading: false, norecords: data.totalRows > 0 ?
                        false : (this.state.initialLoading)
                }
                );
            }
        }
    }
    refreshChart() {

    }
    handleExport = async (exportType: any, selectedColumns: any) => {
        const mode = 'p';
        const columnHeaders: Object = exportTrainingAuthorizationPdf, fileName = 'MyTrainingAuthorizations';
        try {
            if (navigator.onLine) {
                if (this.state.selectedCategory !== undefined) {
                    const data = await loadTableData(
                        getExportQueryFromGridRequest(this.state.selectedCategory.requestBodyForGrid),
                        this.state.selectedCategory
                    );
                    if (data !== undefined) {
                        exportData(selectedColumns, data.rows, exportType, fileName, columnHeaders, mode);
                    }
                }

            }
        } catch (e) { }
    };

    render() {
        const { classes } = this.props;
        const { initialLoading, selectedCategory, rows, totalRows, isLoading, isModuleEnabled, norecords } = this.state;
        return (

            isModuleEnabled && dataTableRenderer(classes, initialLoading, selectedCategory, rows, totalRows,
                this.refreshChart.bind(this), this.loadData.bind(this), this.handleExport.bind(this), isLoading, norecords)

        );
    }
}

export default withStyles(styles)(MyTrainingAuthorizations);
